import script from "./ContextMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContextMenu.vue?vue&type=script&setup=true&lang=ts"

import "./ContextMenu.vue?vue&type=style&index=0&id=52af9d98&lang=less"

const __exports__ = script;

export default __exports__